import { useQuery } from '@tanstack/react-query';
import { preRegistrationApi } from '../api/pre-registration.api';
import { getApiErrorStatus } from '../utils/api-error.utils';
import { preRegistrationKeys } from './usePreRegistrationQueries';

// Municipal list header with all its rows (deleted ones included)
export const useMunicipalList = (id?: string) => {
  return useQuery({
    queryKey: preRegistrationKeys.municipalListDetail(id ?? ''),
    queryFn: () => preRegistrationApi.getMunicipalList(id as string),
    enabled: !!id,
    // A missing list will not appear on retry
    retry: (failureCount, error) => getApiErrorStatus(error) !== 404 && failureCount < 2,
  });
};
